import { render, staticRenderFns } from "./CoreAdvantage.vue?vue&type=template&id=1abd91b6&scoped=true"
import script from "./CoreAdvantage.vue?vue&type=script&lang=js"
export * from "./CoreAdvantage.vue?vue&type=script&lang=js"
import style0 from "./CoreAdvantage.vue?vue&type=style&index=0&id=1abd91b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1abd91b6",
  null
  
)

export default component.exports